// librairie JavaScript SweetAlert pour remplacer les windows.alert
import swal from 'sweetalert';
swal("Le site peut ne pas être adapté à certains écrans.");
// window.alert("Le site peut ne pas être adapté à certains écrans.");


function showTab(tabId) {
  // Masquer tous les contenus
  document.querySelectorAll('.tabContent').forEach(tab => tab.classList.add('hidden'));

  // Afficher le bon contenu
  const target = document.getElementById(tabId);
  if (target) target.classList.remove('hidden');

  // Header et nav
  const header = document.querySelector(".header");
  const navButton = document.querySelector(".nav_button");

  if (tabId !== "content1") {
    header.classList.add("hidden");
    navButton.classList.remove("hidden");

    // 🔹 Lancer l'animation immédiatement pour les autres sections
    switch(tabId) {
      case "projets": startAnimation(projetsLaptop); break;
      case "photo": startAnimation(photoLaptop); break;
      case "creation": startAnimation(creationLaptop); break;
      case "contact": startAnimation(contactsLaptop); break;
    }

  } else {
    // Accueil → animation déclenchée après disparition de l’intro
    navButton.classList.add("hidden");
    if (window.innerWidth <= 900) header.classList.remove("hidden");
    // L'animation de homeLaptop sera lancée après disparition intro, pas ici
  }
}



function startAnimation(section) {
  if (!section) return;

  if (NodeList.prototype.isPrototypeOf(section) || Array.isArray(section)) {
    section.forEach(el => {
      el.classList.remove('anim-start');
      void el.offsetWidth; // forcer reflow
      el.classList.add('anim-start');
    });
  } else {
    section.classList.remove('anim-start');
    void section.offsetWidth;
    section.classList.add('anim-start');
  }
}



// --- Tab Switching depuis boutons principaux ---
document.querySelectorAll(".list--button").forEach(button => {
  button.addEventListener("click", () => {
    const tabId = button.dataset.tab;
    if (tabId) showTab(tabId);
  });
});
function initArrows() {
  const leftArrows = document.querySelectorAll('.diode-left');
  const rightArrows = document.querySelectorAll('.diode-right');

  const leftNormal = "./assets/images/diode-left.svg";
  const leftActive = "./assets/images/diode-left-active.svg";
  const rightNormal = "./assets/images/diode-right.svg";
  const rightActive = "./assets/images/diode-right-active.svg";

  // pour chaque flèche gauche
  leftArrows.forEach(leftArrow => {
    leftArrow.addEventListener('mousedown', () => {
      leftArrow.src = leftActive;
    });
    leftArrow.addEventListener('touchstart', () => {
      leftArrow.src = leftActive;
    });
  });

  // pour chaque flèche droite
  rightArrows.forEach(rightArrow => {
    rightArrow.addEventListener('mousedown', () => {
      rightArrow.src = rightActive;
    });
    rightArrow.addEventListener('touchstart', () => {
      rightArrow.src = rightActive;
    });
  });

  // revenir aux images normales au relâchement (desktop)
  document.addEventListener('mouseup', () => {
    leftArrows.forEach(leftArrow => leftArrow.src = leftNormal);
    rightArrows.forEach(rightArrow => rightArrow.src = rightNormal);
  });

  // revenir aux images normales au relâchement (mobile)
  document.addEventListener('touchend', () => {
    leftArrows.forEach(leftArrow => leftArrow.src = leftNormal);
    rightArrows.forEach(rightArrow => rightArrow.src = rightNormal);
  });
}

initArrows();



// --- Slider ---
function initSlider(sliderRoot) {
  let current = 0;
  const items = sliderRoot.querySelectorAll('.slider-item');
  const nextBtn = sliderRoot.querySelector('.diode-right');
  const prevBtn = sliderRoot.querySelector('.diode-left');

  function showSlide(index) {
    items.forEach(item => item.classList.remove('show'));
    items[index].classList.add('show');
  }

  nextBtn.addEventListener('click', () => {
    current = (current + 1) % items.length;
    showSlide(current);
  });

  prevBtn.addEventListener('click', () => {
    current = (current - 1 + items.length) % items.length;
    showSlide(current);
  });

  showSlide(current); // Afficher la première image
}

document.querySelectorAll('.img-slider').forEach(initSlider);


// --- Burger Menu ---
const navButton = document.querySelector('.nav_button');
const groundIcon = document.querySelector('.ground');
const closeIcon = document.querySelector('.close');
const nav = document.querySelector('.nav');               // menu mobile
const navDesktop = document.querySelector('.nav-desktop'); // menu desktop
const body = document.body;

navButton.addEventListener('click', () => {
  const isOpen = body.hasAttribute('data-menu');

  if (isOpen) {
    // --- fermer le menu ---
    body.removeAttribute('data-menu');
    groundIcon.classList.remove('hidden');
    closeIcon.classList.add('hidden');

    if (window.innerWidth > 900) {
      navDesktop.classList.add('hidden');  // cacher menu desktop
    } else {
      nav.classList.add('hidden');         // cacher menu mobile
    }
  } else {
    // --- ouvrir le menu ---
    body.setAttribute('data-menu', '');
    groundIcon.classList.add('hidden');
    closeIcon.classList.remove('hidden');

    if (window.innerWidth > 900) {
      navDesktop.classList.remove('hidden'); // montrer menu desktop
    } else {
      nav.classList.remove('hidden');        // montrer menu mobile
    }
  }
});



// --- Nav links : changer d'onglet + fermer le menu ---
document.querySelectorAll('.nav__link').forEach(link => {
  link.addEventListener('click', (e) => {
    const tabId = e.target.dataset.tab;
    if (tabId) showTab(tabId);

    nav.classList.add('hidden');
    navDesktop.classList.add('hidden');

    groundIcon.classList.remove('hidden');
    closeIcon.classList.add('hidden');
    body.removeAttribute('data-menu');
  });
});


let homeLaptop = document.querySelector(".home-laptop");
let projetsLaptop = document.querySelector(".projets-laptop");
let photoLaptop = document.querySelector(".photo-laptop");
let creationLaptop = document.querySelector(".creation-laptop");
let contactsLaptop = document.querySelector(".contact-laptop");

let projetsTablet = document.querySelector(".projets-tablet");

let home = document.querySelector(".svg-home");
let projets = document.querySelector(".svg-projets");
let photos = document.querySelector(".photos");
let creations = document.querySelector(".creations");
let contacts = document.querySelector(".contacts");
let svgW = document.querySelector(".svg-w");
let header = document.querySelector(".header");


if (window.screen.width > 900){
  homeLaptop.classList.remove("hidden");
  projetsLaptop.classList.remove("hidden");
  photoLaptop.classList.remove("hidden");
  creationLaptop.classList.remove("hidden");
  contactsLaptop.classList.remove("hidden");

  home.classList.add("hidden");
  projets.classList.add("hidden");
  svgW.classList.add("hidden");
  header.classList.add("hidden");
  photos.classList.add("hidden");
  creations.classList.add("hidden");
  contacts.classList.add("hidden");
  projetsTablet.classList.add("hidden");
} else if (window.screen.width > 800 && window.screen.width < 900){
  projetsTablet.classList.remove("hidden");
  projets.classList.add("hidden");
  home.classList.remove("hidden");
} else {
  home.classList.remove("hidden");
  projets.classList.remove("hidden");
  photos.classList.remove("hidden");
  creations.classList.remove("hidden");
  contacts.classList.remove("hidden");
}


//slider pour projets LAPTOP 
 const projects = [
    { name: "eatingGame",
      url: "http://aurelie-louage.be/projets/eatingGame",
      description: "SEP 2025 - EatingGame est un jeu réalisé avec une librairie JavaScription nommée Phaser.io. Il s'agit d'un jeu remanié suite au projet de groupe iLab en 2021."
    },
    { name: "Loggy",
      url: "http://aurelie-louage.be/assets/images/refonte-esnah.pdf",
      description: "MAR 2025 - Projet de refonte graphique d'une application web dans le cadre de mon stage (lors de mon deuxième bachelier) et code avec le framework Svelte."
     },
    { name: "React",
      url: "http://aurelie-louage.be/projets/HP/video/video-projetHP-final.mp4",
      description: "JAN 2025 - Travail par deux dans le cadre du cours de Technologies d'animations et multimédia. Le but était de réaliser une Progressive Web App contenant une base de données de personnages, ainsi que des informations spécifiques (API)."
    },
    { name: "Refonte",
      url: "http://aurelie-louage.be/projets/refonte/refonte.png",
      description: "DEC 2024 - Relecture et refonte d'un travail web d'un camarade de classe, afin d'améliorer son projet pour le cours de développement web."
     },
    { name: "Ment-e",
      url: "http://aurelie-louage.be/projets/LaboIntegration/video-site-labo-integration.mp4",
      description: "NOV 2024 - Travail de groupe dont le but était de contrôler un distributeur de mentos à distance. Le distibuteur doit, selon le tag RFID de l'utilisateur, prendre une photo de la personne via la caméra ou donner le mentos souhaité."
    },
    { name: "TFE",
      url: "http://aurelie-louage.be/projets/tfe",
      description: "JUN 2022 - Travail de Fin d'Études à la Haute École Albert Jacquard en techniques infographiques. L'idée de cette application est d'apprendre aux enfants (et adultes) à trier les déchets de manière amusante et ludique, selon leur lieu de résidence (en Belgique)."
     },
    { name: "2022",
      url: "http://aurelie-louage.be/projets/2022",
      description: "JUN 2022 - Premier Portfolio officiel en tant que web designer pour montrer l'ensemble de mes projets scolaires et personnels."
    },
    { name: "Pré-au-lard",
      url: "https://www.youtube.com/watch?v=5eeJokvjVIQ",
      description: "AVR 2022 - Vidéo réalisée pour la page Facebook ''Poudlard Plus Qu'une Maison'' sur le village de Pré-au-lard. Avec Marie (la voix off), on a fait beaucoup de recherches sur le sujet, puis je me suis occupée du montage de la vidéo et du script. Contrairement à l'avis global des membres de la page, j'ai souhaité faire de l'humour afin donner envie de regarder jusqu'au bout."
    },
    { name: "Unboxing",
      url: "https://www.youtube.com/watch?v=ZtpQHKUiAmI",
      description: "MAR 2022 - Vidéo réalisée pour la page Facebook ''Poudlard Plus Qu'une Maison'' pour la promotion d'une marque de créateur. Pour cette vidéo, j'ai dû trouver comment donner un aspect fantômatique à la présentatrice puis j'ai monté l'ensemble de la vidéo."
    },
    { name: "BA Narnia",
      url: "http://aurelie-louage.be/projets/BA-Narnia/Narnia-bande-annonce.mp4",
      description: "JAN 2022 - Il s'agit d'une bande annonce personnalisée pour le film Narnia, réalisée avec Adobe Premiere Pro. Cette vidéo est une démonstration de mes compétences en montage vidéo afin de devenir membre d'une page Facebook sur le thème d'Harry Potter. Je n'avais jamais utilisé ce logiciel donc j'ai suivi divers tutoriels sur Youtube pour réaliser la vidéo."
    },
    { name: "Blue-m", url: "https://www.blue-m-style.com/",
      description: "JAN 2022 - Site réalisé avec Odoo pour mon stage. J'ai réorganisé l'ensemble de son contenu puis j'ai procédé au suivi et adaptations des demandes de la cliente."
     },
    { name: "MusicPLZ",
      url: "http://aurelie-louage.be/projets/musicplz",
      description: "NOV 2021 - MusicPLZ est un projet scolaire qui a pour but de présenter un(e) chanteur(euse) que l'on apprécie. Les fonctionnalités principales de ce site sont les animations CSS et le lecteur audio (réalisé avec VanillaJS)."
    },
    { name: "iLab",
      url: "http://aurelie-louage.be/projets/migratio",
      description: "OCT 2021 - Projet de groupe réalisé lors de mon bachelier en techniques infographiques."
     },
    { name: "Dataplay",
      url: "http://aurelie-louage.be/projets/data-play",
      description: "JUN 2021 - Projet de groupe réalisé lors de mon bachelier en techniques infographiques"
     }
  ];

let currentIndex = 0;
const link = document.getElementById("project-link");

// --- Fonction d'affichage avec animation fade ---
function showProject(index) {
  link.style.opacity = 0; // fade-out du lien

  setTimeout(() => {
    link.textContent = projects[index].name;
    link.href = projects[index].url;
    link.style.opacity = 1; // fade-in

    // Mettre à jour la description si la section est visible
    if (isDetailsVisible) {
      descriptionText.textContent = projects[index].description || "Pas de description disponible.";
    }

  }, 300);
}

// --- Fonction pour animer la flèche cliquée ---
function animateArrow(pathEl) {
  pathEl.setAttribute("fill", "#d9d9d9"); // deviens blanc
  setTimeout(() => {
    pathEl.setAttribute("fill", "none"); // retour état initial
  }, 300); // durée visible
}

// --- Navigation flèche gauche ---
document.querySelector(".arrow-left").addEventListener("click", (e) => {
  currentIndex = (currentIndex - 1 + projects.length) % projects.length;
  showProject(currentIndex);

  const path = e.currentTarget.querySelector("path"); // cible uniquement cette flèche
  animateArrow(path);

});

// --- Navigation flèche droite ---
document.querySelector(".arrow-right").addEventListener("click", (e) => {
  currentIndex = (currentIndex + 1) % projects.length;
  showProject(currentIndex);


  const path = e.currentTarget.querySelector("path"); // cible uniquement cette flèche
  animateArrow(path);
});

// --- Initialisation ---
showProject(currentIndex);


//gestion du more (laptop)
const moreButton = document.querySelector('.svg-more');
const detailsSection = document.getElementById('project-details');
const descriptionText = document.getElementById('project-description');

let isDetailsVisible = false;

moreButton.addEventListener('click', () => {
  // Toggle affichage
  isDetailsVisible = !isDetailsVisible;

  if (isDetailsVisible) {
    detailsSection.classList.remove('hidden');
    descriptionText.textContent = projects[currentIndex].description || "Pas de description disponible.";
  } else {
    detailsSection.classList.add('hidden');
  }
});


// Gestion du more (smartphone)
const moreImages = document.querySelectorAll('.img-more');

// Réutilisation des mêmes variables que la version laptop
let currentProjectName = null;

moreImages.forEach(img => {
  img.addEventListener('click', (e) => {
    const parent = e.target.closest('.projets-items');
    const projectName = parent?.dataset?.name;

    // Si on reclique sur le même projet => on ferme
    if (projectName === currentProjectName && isDetailsVisible) {
      detailsSection.classList.add('hidden');
      isDetailsVisible = false;
      currentProjectName = null;
      return;
    }

    // Cherche le projet correspondant
    const project = projects.find(p => p.name === projectName);

    if (project) {
      descriptionText.textContent = project.description || "Pas de description disponible.";
      detailsSection.classList.remove('hidden');
      isDetailsVisible = true;
      currentProjectName = projectName;
    } else {
      // Projet non trouvé
      descriptionText.textContent = "Description non trouvée.";
      detailsSection.classList.add('hidden');
      isDetailsVisible = false;
      currentProjectName = null;
    }
  });
});






const width = window.innerWidth;
const height = window.innerHeight;

console.log("Largeur : " + width + "px");
console.log("Hauteur : " + height + "px");







const switchLine = document.querySelector('.switch');
const mainShape = document.querySelector('.main-shape');
const text = document.querySelector(".text-welcome");

// Calcul exact de la longueur
const length = mainShape.getTotalLength();
mainShape.style.strokeDasharray = -length;
mainShape.style.strokeDashoffset = length; // invisible côté -


const intro = document.getElementById('intro');
const content1 = document.getElementById('content1');
const svgIntro = document.querySelector('.svg-intro');

const popup = document.querySelector('.popup');
const popupOk = document.querySelector('.popup-ok');

popupOk.addEventListener('click', () => {
  popup.style.display = "none";
  intro.style.display = "block";
  svgIntro.classList.add('show');
  svgIntro.style.filter = "brightness(100%)";
});

switchLine.addEventListener('click', () => switchLine.classList.add('active'));

switchLine.addEventListener('transitionend', (e) => {
  if (e.propertyName === 'transform') {
    mainShape.style.stroke = 'white';
    switchLine.style.stroke = 'white';
    text.classList.add('show');

    // Déclencher la transition du tracé
    mainShape.style.transition = 'stroke-dashoffset 1s linear';
    // Reset juste au cas où
    mainShape.style.strokeDashoffset = length;
    // Utiliser un petit délai pour forcer la transition
    setTimeout(() => {
      mainShape.style.strokeDashoffset = 0;
    }, 50);
  }
});


// Après disparition de l'intro
mainShape.addEventListener('transitionend', (e) => {
  if (e.propertyName === 'stroke-dashoffset') {
    // Fade intro → content1
    intro.style.transition = "opacity 1s ease";
    content1.style.transition = "opacity 1s ease";

    void intro.offsetWidth; // forcer reflow
    intro.style.opacity = "0";
    content1.style.opacity = "1";

    // 🔹 Lancer l’animation de l’accueil après la transition
    setTimeout(() => {
      intro.style.display = "none";
      content1.style.display = "block";

      // --- Réinitialiser les éléments home avant l'animation ---
      const accueil = homeLaptop; // ou .accueil
      const lines = accueil.querySelectorAll('.home-line');
      const circles = accueil.querySelectorAll('.home-circle');
      const blocks = accueil.querySelectorAll('.home-block');

      lines.forEach(el => el.style.strokeDashoffset = '2000');
      circles.forEach(el => {
        el.style.strokeDashoffset = '2000';
        el.style.opacity = '0';
      });
      blocks.forEach(el => el.style.opacity = '0');

      void accueil.offsetWidth; // forcer reflow

      // --- Ajouter la classe anim-start pour déclencher l'animation ---
      accueil.classList.remove('anim-start');
      void accueil.offsetWidth; // forcer reflow
      accueil.classList.add('anim-start');

    }, 1000); // correspond à la durée du fade
  }
});
